export const applicationUi = {
  itemsPerPage: 20
};
